import api from '@/api';
import { API_BASE_URL } from '../../index';
import { AbcCurveRequest } from './abcCurve.types';

const CONTROLLER_URL = `${API_BASE_URL}/generate`;

export async function getAbcCurveReport(params: AbcCurveRequest) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/abc-curve`,
    params,
  )) as unknown;

  return result as BlobPart;
}
